import api from '@/services/index';

export default {
  namespaced: true,
  state: {
    test: null,
    errors: {
      saveTestResult: {},
      getTestResult: {},
    },
  },
  mutations: {
    SET_ERRORS(state, error) {
      state.errors[error.key] = error.val;
    },
    SET_TEST(state, payload) {
      state.test = payload;
    },
  },
  actions: {
    async saveTestResult({ commit }, data) {
      commit('SET_ERRORS', {
        key: 'saveTestResult',
        val: {},
      });

      const url = '/tests';

      try {
        const resp = await api.post(url, data);
        return resp.data;
      } catch (e) {
        if (e.response && e.response.data) {
          console.log(e.response.data);
          commit('SET_ERRORS', {
            key: 'saveTestResult',
            val: e.response.data,
          });
        } else {
          console.log(`Ошибка ${e.message}`);
          commit('SET_ERRORS', {
            key: 'saveTestResult',
            val: { error: 'Ошибка' },
          });
        }
      }
      return false;
    },
    async getTestResult({ commit }, data) {
      commit('SET_ERRORS', {
        key: 'getTestResult',
        val: {},
      });

      const url = `/tests/${data.uuid}`;

      try {
        const resp = await api.get(url);
        commit('SET_TEST', resp.data);
        return resp.data;
      } catch (e) {
        if (e.response && e.response.data) {
          console.log(e.response.data);
          commit('SET_ERRORS', {
            key: 'getTestResult',
            val: e.response.data,
          });
        } else {
          console.log(`Ошибка ${e.message}`);
          commit('SET_ERRORS', {
            key: 'getTestResult',
            val: { error: 'Ошибка' },
          });
        }
      }
      return false;
    },
  },
};
